import { render, staticRenderFns } from "./UploadLink.vue?vue&type=template&id=f250d472&scoped=true"
import script from "./UploadLink.vue?vue&type=script&lang=js"
export * from "./UploadLink.vue?vue&type=script&lang=js"
import style0 from "./UploadLink.vue?vue&type=style&index=0&id=f250d472&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f250d472",
  null
  
)

export default component.exports